import { render, staticRenderFns } from "./EditPriceApply.vue?vue&type=template&id=f2e4bcd6&scoped=true"
import script from "./EditPriceApply.vue?vue&type=script&lang=js"
export * from "./EditPriceApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e4bcd6",
  null
  
)

export default component.exports